import { Session, User } from "@supabase/supabase-js";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { AccessLevel } from "../../models/enums/AccessLevel";
import { getPrefixedStorageName } from "../../utils/storagePrefix";

export interface UserInfo {
	info: User;
	session: Session;
	role: AccessLevel;
	authenticated: boolean;
}

type State = {
	user: UserInfo;
};

type Action = {
	updateUser: (data: State["user"]) => void;
};

export const userStore = create(
	persist<State & Action>(
		(set) => ({
			user: {
				info: new Object() as User, 
				session: new Object() as Session,
				authenticated: false,
				role: AccessLevel.Public
			},
			updateUser: (data) =>
				set(() => ({
					user: {
						info: data.info,
						session: data.session,
						authenticated: data.authenticated,
						role: data.role
					},
				})),
		}),
		{
			name: getPrefixedStorageName('user-storage'),
			storage: createJSONStorage(() => AsyncStorage),
		}
	)
);
